import client from "application/apollo/apolloClient";
import includeHeaders from "application/hoc/includeHeaders";

const apolloGetMutation = (query, headers) =>
  new Promise((resolve, reject) => {
    client
      .mutate(includeHeaders(query, headers))
      .then((result) => resolve(result))
      .catch((err) => reject(err));
  });

export default apolloGetMutation;
